/* eslint-disable */
import { Project, Person, Metadata } from '../index';

declare var Object: any;
export interface TenantInterface {
  id?: string;
  name?: string;
  isDeleted?: boolean;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
  projects?: Project[];
  members?: Person[];
  metadata?: Metadata[];
}

export class Tenant implements TenantInterface {
  'id'?: string;
  'name': string;
  'isDeleted': boolean;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  projects: Project[];
  members: Person[];
  metadata: Metadata[];
  constructor(data?: TenantInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tenant`.
   */
  public static getModelName() {
    return 'Tenant';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of Tenant for dynamic purposes.
   **/
  public static factory(data: TenantInterface): Tenant {
    return new Tenant(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'Tenant',
      plural: 'Tenants',
      path: 'tenants',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        name: {
          name: 'name',
          type: 'string',
        },
        isDeleted: {
          name: 'isDeleted',
          type: 'boolean',
          default: false,
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
      },
      relations: {
        projects: {
          name: 'projects',
          type: 'Project[]',
          model: 'Project',
          relationType: 'hasMany',
          keyFrom: 'id',
          keyTo: 'tenantId',
        },
        members: {
          name: 'members',
          type: 'Person[]',
          model: 'Person',
          relationType: 'hasMany',
          keyFrom: 'id',
          keyTo: 'tenantId',
        },
        metadata: {
          name: 'metadata',
          type: 'Metadata[]',
          model: 'Metadata',
          relationType: 'hasMany',
          keyFrom: 'id',
          keyTo: 'tenantId',
        },
      },
    };
  }
}
